/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './src/theme/theme-vars';
import { muiTheme } from './src/theme/mui-theme';

export const wrapRootElement = ({ element }) => (
  <MuiThemeProvider theme={muiTheme}>
    <ThemeProvider theme={theme}>{element}</ThemeProvider>
  </MuiThemeProvider>
);

export const onInitialClientRender = () => {
  // Remove the SSR-injected JSS styles so client-side MUI can manage CSS
  const jssStyles = document.getElementById('jss-server-side');
  if (jssStyles && jssStyles.parentNode) {
    jssStyles.parentNode.removeChild(jssStyles);
  }

  const el = document.getElementById('components-page');
  if (!el) {
    document.documentElement.classList.add('page-ready');
    return;
  }

  const minHeight = 600;

  const isComponentReady = () => {
    const hasChildren = el.childElementCount > 0;
    const tallEnough = el.getBoundingClientRect().height >= minHeight;

    if (hasChildren && tallEnough) {
      document.documentElement.classList.add('page-ready');
      return true;
    }
    return false;
  };

  if (isComponentReady()) return;

  const obs = new MutationObserver(() => {
    if (isComponentReady()) obs.disconnect();
  });

  obs.observe(el, { childList: true, subtree: true });

  setTimeout(() => {
    obs.disconnect();
    document.documentElement.classList.add('page-ready');
  }, 3000);
};
